import app from '@/app';
import templateUrl from './importHistory-page.html';

/* @ngInject */
function ImportHistoryPageController($controller, $state, $http, Principal, $uibModal) {
	var $ctrl = this;

	$ctrl.currentAccount = null;
	$ctrl.importHistory = [];

	$ctrl.startDatePickerOpen = false;
	$ctrl.endDatePickerOpen = false;

	$ctrl.dateOptions = {
		formatYear: 'yyyy',
		startingDay: 1,
		showWeeks: false
	};

	// Initialize filter with the last 2 days
	const today = new Date();
	const twoDaysAgo = new Date();
	today.setHours(0, 0, 0, 0);
	twoDaysAgo.setHours(0, 0, 0, 0);
	twoDaysAgo.setDate(today.getDate() - 2);
	$ctrl.fromDate = twoDaysAgo;
	$ctrl.toDate = today;

	$ctrl.status = null;
	$ctrl.importType = null;

	Principal.identity().then(account => {
		$ctrl.currentAccount = account;
	});

	$controller('AbstractPageSortController', { $ctrl });

	// Convert local Date → 'YYYY-MM-DD' for backend submission
	const formatDate = (d) => {
		if (!d || !(d instanceof Date) || isNaN(d)) return null;
		const year = d.getFullYear();
		const month = String(d.getMonth() + 1).padStart(2, '0');
		const day = String(d.getDate()).padStart(2, '0');
		return `${year}-${month}-${day}`;
	};

	const loadPage = (params) => {
		$ctrl.loading = true;
		$http.get('/api/import-history/search', {
			params: {
				from:       params.from       || null,
				to:         params.to         || null,
				status:     params.status     || null,
				importType: params.importType || null,
				sort:       params.sort       || 'startDate,desc',
				page:       $ctrl.page,
				size:       $ctrl.size
			}
		}).then(response => {
			$ctrl.importHistory = response.data.content;
			$ctrl.count         = response.data.totalElements;
		}).catch(error => {
			console.error('Erro ao carregar histórico:', error);
		}).finally(() => {
			$ctrl.loading = false;
		});
	};

	var transition = $ctrl.transition;
	$ctrl.transition = params => {
		transition(params);
		// Restore URL filters when navigating back or paginating
		if (params.from) $ctrl.fromDate = new Date(params.from + 'T12:00:00');
		if (params.to)   $ctrl.toDate   = new Date(params.to   + 'T12:00:00');
		if (params.status)     $ctrl.status     = params.status;
		if (params.importType) $ctrl.importType = params.importType;
		loadPage(params);
	};

	// Apply filters and reset to page 0, preserving filters in URL
	$ctrl.onQueryChange = () => {
		const from = formatDate($ctrl.fromDate);
		const to   = formatDate($ctrl.toDate);

		if (from && to && from > to) {
			alert('Período inválido: data inicial é posterior à data final.');
			return;
		}

		// reload: true forces a refresh even when the params are unchanged,
		// so a process started moments ago shows up without leaving the page.
		$state.go($state.current, {
			page:       0,
			from:       from,
			to:         to,
			status:     $ctrl.status     || null,
			importType: $ctrl.importType || null
		}, { reload: true });
	};

	// TODO: Temporary — subtract 3h (UTC → BRT). Remove when backend handles timezones properly.
	$ctrl.adjustTimezone = (dateStr) => {
		if (!dateStr) return null;
		const d = new Date(dateStr);
		d.setHours(d.getHours() - 3);
		return d;
	};

	$ctrl.showErrors = (importRecord) => {
		$http.get(`/api/import-history/${importRecord.id}/errors`)
			.then(response => {
				importRecord.errors = response.data;
				$uibModal.open({
					templateUrl: '/app/analysis/importHistory/importHistory-errorModal.html',
					size: 'lg',
					controller: ['$scope', '$uibModalInstance', ($scope, $uibModalInstance) => {
						$scope.importRecord = importRecord;

						// Client-side pagination of the loaded error list (10 per page)
						$scope.pageSize = 10;
						$scope.currentPage = 1;
						$scope.totalErrors = (importRecord.errors || []).length;
						$scope.totalPages = Math.max(1, Math.ceil($scope.totalErrors / $scope.pageSize));

						$scope.prevPage = () => {
							if ($scope.currentPage > 1) $scope.currentPage--;
						};
						$scope.nextPage = () => {
							if ($scope.currentPage < $scope.totalPages) $scope.currentPage++;
						};

						$scope.close = () => $uibModalInstance.dismiss();
					}]
				});
			})
			.catch(error => {
				console.error('Erro ao carregar erros:', error);
			});
	};
}

app.component('importHistoryPage', {
	templateUrl,
	controller: ImportHistoryPageController,
	bindings: { $transition$: '<' }
});
